import * as actions from "../global/actionTypes";

const initState = {
  keyword: "",
  fleetIds: [],
};

export default function (state = initState, action = {}) {
  switch (action.type) {
    case actions.UPDATE_KEYWORD:
      return {
        ...state,
        keyword: action.keyword,
      };
    case actions.UPDATE_FILTER_STATE:
      return {
        ...state,
        fleetIds: action.filter.fleetIds,
      };
    case actions.FETCH_JOB_REQUEST:
      return {
        ...state,
        fleetIds: [],
      };
    case actions.FETCH_JOB_SUCCESS: {
      const fleetIds = Object.keys(action.response.data.input.fleet);

      return {
        ...state,
        fleetIds: [...fleetIds, "unserved"],
      };
    }
    default:
      return state;
  }
}
